// import React, { useEffect } from "react";
// import Paper from "@mui/material/Paper";
// import Box from "@mui/material/Box";
// import { styled } from "@mui/material/styles";
// import { Button, TablePagination, ToggleButton } from "@mui/material";
// import Grid from "@mui/material/Grid";
// import Typography from "@mui/material/Typography";
// import TextField from "@mui/material/TextField";
// import FormGroup from "@mui/material/FormGroup";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import FormControl from "@mui/material/FormControl";
// import { useState } from "react";
// import Select, { SelectChangeEvent } from "@mui/material/Select";
// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
// import createInstance from "../../../api/axiosinstance";
// import Toast from "../../../utils/toast";
// // import COLORS from "../../Themes/Colours";
// import { useThemeMode } from "../../Themes/ThemeContextTemp.js";


// const Item = styled(Paper)(({ theme }) => ({
//   backgroundColor: theme.palette.mode === "dark" ? " #1A2027" : "#fff",
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: "center",
//   color: theme.palette.text.secondary,
// }));
// const CssTextField = styled(TextField)({
//   "& label": {
//     color: COLORS.text,
//   },
//   "& .MuiInput-underline:after": {
//     borderBottomColor: COLORS.border,
//   },
//   "& .MuiOutlinedInput-root": {
//     "& fieldset": {
//       borderColor: COLORS.border,
//       borderRadius: 10,
//     },
//     "&:hover fieldset": {
//       borderColor: COLORS.border,
//     },
//     "&.Mui-focused fieldset": {
//       borderColor: COLORS.border,
//     },
//     "& .MuiInputBase-input": {
//       // Add this line
//       color: COLORS.text, // Change the color here
//     },
//   },
// });

// const CssFormControl = styled(FormControl)({
//   "& label": {
//     color: COLORS.text,
//     "&.Mui-focused": {
//       color: COLORS.text,
//     },
//   },
//   "& .MuiInputBase-root": {
//     color: COLORS.text,
//     "& .MuiOutlinedInput-notchedOutline": {
//       borderColor: COLORS.border,
//       borderRadius: 10,
//     },
//     "&:hover .MuiOutlinedInput-notchedOutline": {
//       borderColor: COLORS.border,
//     },
//     "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//       borderColor: COLORS.border,
//     },
//   },
// });

// const CssSelect = styled(Select)({
//   "& .MuiSvgIcon-root": {
//     color: COLORS.text,
//     textAlign: "center",
//   },
// });

// const JobDescription = () => {
//   const aiDishaApi = createInstance("DISHA");
//   const [jobTitle, setJobTitle] = useState("");
//   const [yearsOfExpList, setYearsOfExpList] = useState([]);
//   const [yearsOfExperience, setYearsOfExperience] = useState("");
//   const [activeCities, setActiveCities] = useState([]);
//   const [city, setCity] = useState("");
//   const [state, setState] = useState("");
//   const [salaryRangeList, setSalaryRangeList] = useState([]);
//   const [salaryRange, setSalaryRange] = useState("");
//   const [employeeType, setEmployeeType] = useState("");
//   const [jobDescription, setJobDescription] = useState("");
//   const [responsibility, setResponsibility] = useState("");
//   const [activeSkills, setActiveSkills] = useState([]);
//   const [requiredSkills, setRequiredSkills] = useState([]);
//   const [additionalSkills, setAdditionalSkills] = useState("");
//   const [functionalArea, setFunctionalArea] = useState("");
//   const [designations, setDesignations] = useState([]);
//   const [designation, setDesignation] = useState("");
//   const [aboutCompany, setAboutCompany] = useState("");
//   const [educationDetails, setEducationDetails] = useState([]);
//   const [educationDetailsUg, setEducationDetailsUg] = useState([]);
//   const [educationDetailsPg, setEducationDetailsPg] = useState([]);
//   const [benefits, setBenefits] = useState("");
//   const [isOthersUg, setIsOthersUg] = useState(false);
//   const [isOthersPg, setIsOthersPg] = useState(false);
//   const [ugDegree, setUgDegree] = useState("");
//   const [pgDegree, setPgDegree] = useState("");
//   const { COLORS } = useThemeMode();
//   const organizationId = window.sessionStorage.getItem("organizationId");
//   console.log("ORGID" + organizationId);

//   //const [allDropdownValues, setAllDropdownValues] = useState({});

//   useEffect(() => {
//     getActiveCities();
//     getActiveSkills();
//     getUgDetails();
//     getPgDetails();
//     getAllDropdownValues();
//   }, []);

//   const getAllDropdownValues = async () => {
//     await aiDishaApi
//       .get("/job_all_dropdown")
//       .then((response) => {
//         const values = response.data;
//         setYearsOfExpList(values["experience_yrs"]);
//         setSalaryRangeList(values["salary_range"]);
//         setDesignations(values["designation"]);
//         console.log(response.data);
//       })
//       .catch((error) => {
//         console.error(
//           "Error fetching the list of values for the drop downs",
//           error
//         );
//       });
//   };

//   //To Fetch all the 'Active' cities (irrespective of the state or district)
//   const getActiveCities = async () => {
//     await aiDishaApi
//       .get("/Cities/active")
//       .then((response) => {
//         setActiveCities(response.data);
//         console.log(response.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching active cities" + error);
//       });
//   };

//   //To get the State Name corresponding to the city selected by the user
//   const getStateName = async (city) => {
//     setCity(city);
//     await aiDishaApi
//       .get(`/statenames_based_on_city?city=${city}`)
//       .then((response) => {
//         response.data.state ? setState(response.data.state) : setState("");
//         console.log("State is *********" + response.data.state);
//       })
//       .catch((error) => {
//         console.error("Error fetching state name for the given city", error);
//       });
//   };

//   // To get all 'active' skills from Skill table
//   const getActiveSkills = async () => {
//     await aiDishaApi
//       .get("/skills-show/active")
//       .then((response) => {
//         const skillData = response.data;
//         setActiveSkills(skillData);
//         console.log("skills values" ,skillData);
//         const skillNames = skillData.map(skill => skill.skill_name);
//         console.log("All Skill Names:", skillNames);
//       })
//       .catch((error) => {
//         console.error("Error fetching active skills" + error);
//       });
//   };

//   const getUgDetails = async () => {
//     // setEducationDetailsUg(["B.E. Computer Science", "B.Sc.Computer Science", "B.E.
//     //Information Technology","Others(b)"]);
//     await aiDishaApi
//       .get("/undergraduate_degrees")
//       .then((response) => {
//         setEducationDetailsUg(response.data);
//         console.log(response.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching UG details" + error);
//       });
//   };

//   const getPgDetails = async () => {
//     //setEducationDetailsPg(["M.E. Computer Science", "M.Sc.Computer Science", "M.E.
//     //Information Technology","Others(m)"]);
//     await aiDishaApi
//       .get("/postgraduate_degrees")
//       .then((response) => {
//         setEducationDetailsPg(response.data);
//         console.log(response.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching PG details" + error);
//       });
//   };

//   const setEduDetails = (event) => {
//     console.log(event);
//     setEducationDetails(event);
//     //validateEdu(event);

//     setIsOthersUg(event.includes("Others(UG)") ? true : false);
//     setIsOthersUg(event.includes("Others(UG)") ? true : false);

//     setIsOthersPg(event.includes("Others(PG)") ? true : false);
//     setIsOthersPg(event.includes("Others(PG)") ? true : false);

//     console.log("UG others ? " + isOthersUg);
//     console.log("PG others ? " + isOthersPg);
//   };

//   const saveJobDetails = async (event) => {
//     event.preventDefault();

//     if (!jobTitle.trim()) {
//       console.error("Job title cannot be empty");
//       Toast.error("Job title cannot be empty");
//       return;
//     }

//     if (!yearsOfExperience.trim()) {
//       console.error("Experience cannot be empty");
//       Toast.error("Experience cannot be empty");
//       return;
//     }

//     if (!city.trim()) {
//       console.error("City cannot be empty");
//       Toast.error("City cannot be empty");
//       return;
//     }

//     if (!salaryRange.trim()) {
//       console.error("Salary Range be empty");
//       Toast.error("Salary Range cannot be empty");
//       return;
//     }

//     if (!employeeType.trim()) {
//       console.error("Employee Type be empty");
//       Toast.error("Employee Type cannot be empty");
//       return;
//     }

//     if (!jobDescription.trim()) {
//       console.error("Job Description be empty");
//       Toast.error("Job Description cannot be empty");
//       return;
//     }
//     if (!responsibility.trim()) {
//       console.error("Responsibility be empty");
//       Toast.error("Responsibility cannot be empty");
//       return;
//     }

//     if (requiredSkills.length === 0) {
//       console.error("Required Skills cannot be empty");
//       Toast.error("Required Skills cannot be empty");
//       return;
//     }

//     if (!aboutCompany.trim()) {
//       console.error("Company details cannot be empty");
//       Toast.error("Company details cannot be empty");
//       return;
//     }

//     if (!designation.trim()) {
//       console.error("Designation cannot be empty");
//       Toast.error("Designation cannot be empty");
//       return;
//     }

//     if (educationDetails.length === 0) {
//       console.error("Educational Details cannot be empty");
//       Toast.error("Educational Details cannot be empty");
//       return;
//     }

//     if (isOthersUg && !ugDegree.trim()) {
//       console.error("UG Details cannot be empty");
//       Toast.error("UG Details cannot be empty");
//       return;
//     }

//     if (isOthersPg && !pgDegree.trim()) {
//       console.error("PG Details cannot be empty");
//       Toast.error("PG Details cannot be empty");
//       return;
//     }

//     if (isOthersUg || isOthersPg) {
//       var ugIndex = educationDetails.indexOf("Others(UG)");
//       var pgIndex = educationDetails.indexOf("Others(UG)");
//       educationDetails.splice(ugIndex, 1);
//       educationDetails.splice(pgIndex, 1);

//       educationDetails.push(ugDegree);
//       educationDetails.push(pgDegree);
//     }

//     console.log(
//       "Title = " +
//         jobTitle +
//         "\n Exp = " +
//         yearsOfExperience +
//         "\n city = " +
//         city +
//         "\n state = " +
//         state +
//         "\n salary = " +
//         salaryRange +
//         "\n etype = " +
//         employeeType +
//         "\n jobdesc = " +
//         jobDescription +
//         "\n resp = " +
//         responsibility +
//         "\n req skills = " +
//         requiredSkills +
//         "\n add skills = " +
//         additionalSkills +
//         "\n funcArea = " +
//         functionalArea +
//         "\n designation = " +
//         designation +
//         "\n abt comp = " +
//         aboutCompany +
//         "\n benifits = " +
//         benefits +
//         "\n edu details = " +
//         educationDetails +
//         "\n ugDegree = " +
//         ugDegree +
//         "\n pgDegree = " +
//         pgDegree
//     );

//     await aiDishaApi
//       .post(
//         "/org-insert-job/",
//         {
//           org_id: organizationId,
//           job_title: jobTitle,
//           job_description: jobDescription,
//           company_info: aboutCompany,
//           responsibility: responsibility,
//           status: "Active",
//           additional_skills: additionalSkills,
//           benefits: benefits,
//         },
//         {
//           params: {
//             Education_Details: educationDetails,
//             Functional_area: functionalArea,
//             Required_Skills: requiredSkills,
//             city: city,
//             designation: designation,
//             emp_type: employeeType,
//             experience_yrs: yearsOfExperience,
//             salary_range: salaryRange,
//             state: state,
//           },
//           paramsSerializer: {
//             indexes: null,
//           },
//         }
//       )
//       .then((response) => {
//         console.log(response.data);
//         clearForm();
//         Toast.success("Job created successfully");
//       })
//       .catch((error) => {
//         console.error("Error creating job", error);
//       });
//   };

//   const clearForm = () => {
//     setJobTitle("");
//     setYearsOfExperience("");
//     setCity("");
//     setState("");
//     setSalaryRange("");
//     setEmployeeType("");
//     setJobDescription("");
//     setResponsibility("");
//     setRequiredSkills([]);
//     setAdditionalSkills("");
//     setFunctionalArea("");
//     setDesignation("");
//     setAboutCompany("");
//     setBenefits("");
//     setEducationDetails([]);
//   };

//   return (
//     <div
//       style={{
//         height: "calc(100% - 6%)",
//         overflow: "scroll",
//         overflowX: "hidden",
//         scrollbarWidth: "thin", // For Firefox
//         msOverflowStyle: "none", // For Internet Explorer
//         scrollbarColor: "transparent transparent", // For Firefox
//         "&::-webkit-scrollbar": {
//           width: "5px", // Width of the scrollbar
//           height: "5px",
//         },
//       }} // Height of the scrollbar
//     >
//       <Box
//         display="grid"
//         gridTemplateColumns="repeat(12, 1fr)"
//         sx={{
//           marginTop: "auto",
//           alignItems: "center",
//           borderRadius: "10px",
//           padding: "1% 10%",
//         }}
//       >
//         <Box
//           gridColumn="span 12"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "0%" }}
//         >
//           <Typography
//             sx={{
//               fontFamily: "poppins",
//               fontSize: "28px",
//               color: COLORS.text,
//               mb: "2%",
//             }}
//           >
//             Add New Job
//           </Typography>
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Job Title<span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssTextField
//             label="Enter Job Title"
//             id="custom-css-outlined-input"
//             size="small"
//             sx={{ width: "90%", mb: "2%",background:COLORS.primary }}
//             value={jobTitle}
//             onChange={(e) => setJobTitle(e.target.value)}
//             required={true}
//             disabled={false}
//           />
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Experience(in Years)<span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssFormControl sx={{ width: "90%", color: "#FFFFFF" }}>
//             <InputLabel>Select Experience</InputLabel>
//             <CssSelect
//               label="Experience"
//               id="demo-simple-select-outlined"
//               size="small"
//               value={yearsOfExperience}
//               onChange={(e) => setYearsOfExperience(e.target.value)}
//               sx={{ width: "100%", textAlign: "center",background:COLORS.primary }}
//               required={true}
//               disabled={false}
//             >
//               <MenuItem
//                 key="yearsOfExp"
//                 value="yearsOfExp"
//                 disabled={true}
//                 sx={{ color: "black", }}
//               >
//                 Select Experience
//               </MenuItem>
//               {yearsOfExpList.map((exp) => (
//                 <MenuItem
//                   key={exp}
//                   value={exp}
//                   sx={{ color: "black", }}
//                 >
//                   {exp}
//                 </MenuItem>
//               ))}
//             </CssSelect>
//           </CssFormControl>
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             City<span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssFormControl sx={{ width: "90%" }}>
//             <InputLabel>Select city</InputLabel>
//             <CssSelect
//               label="City"
//               id="demo-simple-select-outlined"
//               size="small"
//               value={city}
//               onChange={(e) => getStateName(e.target.value)}
//               sx={{ width: "100%", textAlign: "center",background:COLORS.primary }}
//             >
//               {activeCities.map((city) => (
//                 <MenuItem
//                   key={city.city_name}
//                   value={city.city_name}
//                   sx={{ color: "black",  }}
//                 >
//                   {city.city_name}
//                 </MenuItem>
//               ))}
//             </CssSelect>
//           </CssFormControl>
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             State
//           </Typography>

//           <CssTextField
//             id="custom-css-outlined-input"
//             size="small"
//             sx={{ width: "90%", mb: "2%",background:COLORS.primary }}
//             value={state}
//             disabled={true}
//           />
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Salary Range<span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssFormControl sx={{ width: "90%" }}>
//             <InputLabel>Select Salary Range</InputLabel>
//             <CssSelect
//               label="Salary Range"
//               id="demo-simple-select-outlined"
//               size="small"
//               value={salaryRange}
//               onChange={(e) => setSalaryRange(e.target.value)}
//               sx={{ width: "100%", textAlign: "center",background:COLORS.primary }}
//               required={true}
//               disabled={false}
//             >
//               <MenuItem
//                 key="salaryrange"
//                 value="salaryRange"
//                 disabled={true}
//                 sx={{ color: "black",  }}
//               >
//                 Select Salary Range
//               </MenuItem>
//               {salaryRangeList.map((sal) => (
//                 <MenuItem
//                   key={sal}
//                   value={sal}
//                   sx={{ color: "black",  }}
//                 >
//                   {sal}
//                 </MenuItem>
//               ))}
//             </CssSelect>
//           </CssFormControl>
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{
//             marginTop: "auto",
//             textAlign: "left",
//             width: "90%",
//             marginBottom: "2%",
//           }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Employee Type<span style={{ color: "red" }}>*</span>
//           </Typography>

//           <ToggleButtonGroup color="primary" value={employeeType} exclusive>
//             <ToggleButton
//               style={{
//                 border: "1px solid",
//                 borderColor: "#B9B9B9",
//                 borderRadius: "10px",
//                 color: COLORS.text,
//                 background:COLORS.primary,
//                 fontFamily: "poppins",
//                 fontSize: "12px",
//               }}
//               value="Full Time"
//               selectedColor="#12344553"
//               onClick={(e) => setEmployeeType(e.target.value)}
//             >
//               Full Time
//             </ToggleButton>
//             <ToggleButton
//               selectedColor="#ffffffe8"
//               style={{
//                 border: "1px solid",
//                 borderColor: "#B9B9B9",
//                 borderRadius: "10px",
//                 color: COLORS.text,
//                 background:COLORS.primary,
//                 fontFamily: "poppins",
//                 fontSize: "12px",
//               }}
//               value="Part Time"
//               onClick={(e) => setEmployeeType(e.target.value)}
//             >
//               Part Time
//             </ToggleButton>
//             <ToggleButton
//               selectedColor="#FFFFFF"
//               style={{
//                 border: "1px solid",
//                 borderColor: "#B9B9B9",
//                 borderRadius: "10px",
//                 color: COLORS.text,
//                 background:COLORS.primary,
//                 fontFamily: "poppins",
//                 fontSize: "12px",
//               }}
//               value="Contract"
//               onClick={(e) => setEmployeeType(e.target.value)}
//             >
//               Contract
//             </ToggleButton>
//             <ToggleButton
//               selectedColor="#FFFFFF"
//               style={{
//                 border: "1px solid",
//                 borderColor: "#B9B9B9",
//                 borderRadius: "10px",
//                 color: COLORS.text,
//                 background:COLORS.primary,
//                 fontFamily: "poppins",
//                 fontSize: "12px",
//               }}
//               value="Internship"
//               onClick={(e) => setEmployeeType(e.target.value)}
//             >
//               Internship
//             </ToggleButton>
//           </ToggleButtonGroup>
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", width: "90%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Job Description
//             <span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssTextField
//             id="outlined-multiline-flexible"
//             label="Enter Job Description"
//             multiline
//             rows={2}
//             sx={{ width: "100%", mb: "2%",background:COLORS.primary }}
//             value={jobDescription}
//             onChange={(e) => setJobDescription(e.target.value)}
//           />
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", width: "90%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Responsibility
//             <span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssTextField
//             id="outlined-multiline-flexible"
//             label="Enter Responsibilities"
//             multiline
//             rows={2}
//             sx={{ width: "100%", mb: "2%",background:COLORS.primary }}
//             value={responsibility}
//             onChange={(e) => setResponsibility(e.target.value)}
//           />
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Required Skills
//             <span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssFormControl sx={{ width: "90%" }}>
//             <InputLabel>Select Skills</InputLabel>
//             <CssSelect
//               multiple={true}
//               label="Select Type of Sector"
//               id="demo-simple-select-outlined"
//               size="small"
//               sx={{ width: "100%", textAlign: "center", mb: "2%",background:COLORS.primary }}
//               value={requiredSkills}
//               onChange={(e) => setRequiredSkills(e.target.value)}
//             >
//               {(activeSkills || []).map((skill, index) => (
//                 <MenuItem
//                   key={skill.skill_name}
//                   value={skill.skill_name}
//                   sx={{ color: "black",  }}
//                 >
//                   {skill.skill_name}
//                 </MenuItem>
//               ))}
//             </CssSelect>
//           </CssFormControl>
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Additional Skills
//           </Typography>
//           <CssTextField
//             label="Enter Additional Skills"
//             id="custom-css-outlined-input"
//             size="small"
//             sx={{ width: "90%", mb: "2%",background:COLORS.primary }}
//             value={additionalSkills}
//             onChange={(e) => setAdditionalSkills(e.target.value)}
//           />
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color:COLORS.text, textAlign: "left" }}
//           >
//             Functional Area
//           </Typography>
//           <CssTextField
//             label="Enter Functional Area"
//             id="custom-css-outlined-input"
//             size="small"
//             sx={{ width: "90%", mb: "2%",background:COLORS.primary }}
//             value={functionalArea}
//             onChange={(e) => setFunctionalArea(e.target.value)}
//           />
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Designation<span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssFormControl sx={{ width: "90%" }}>
//             <InputLabel>Select Designation</InputLabel>
//             <CssSelect
//               label="Select Role"
//               id="demo-simple-select-outlined"
//               size="small"
//               sx={{ width: "100%", textAlign: "center", mb: "2%",background:COLORS.primary }}
//               value={designation}
//               onChange={(e) => setDesignation(e.target.value)}
//             >
//               <MenuItem
//                 key="designation"
//                 value="designation"
//                 disabled={true}
//                 sx={{ color: "black" }}
//               >
//                 Select Designation
//               </MenuItem>
//               {designations.map((desig) => (
//                 <MenuItem
//                   key={desig}
//                   value={desig}
//                   sx={{ color: "black", }}
//                 >
//                   {desig}
//                 </MenuItem>
//               ))}
//             </CssSelect>
//           </CssFormControl>
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{
//             marginTop: "auto",
//             textAlign: "left",
//             width: "90%",
//             marginBottom: "2%",
//           }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             About the Company<span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssTextField
//             id="outlined-multiline-flexible"
//             label="Enter details about the company"
//             multiline
//             rows={2}
//             sx={{ width: "100%", mb: "2%",background:COLORS.primary }}
//             value={aboutCompany}
//             onChange={(e) => setAboutCompany(e.target.value)}
//           />
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{
//             marginTop: "auto",
//             textAlign: "left",
//             width: "90%",
//             marginBottom: "2%",
//           }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Benefits
//           </Typography>
//           <CssTextField
//             id="outlined-multiline-flexible"
//             label="Enter Benefits"
//             multiline
//             rows={2}
//             sx={{ width: "100%", mb: "2%",background:COLORS.primary }}
//             value={benefits}
//             onChange={(e) => setBenefits(e.target.value)}
//           />
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text ,textAlign: "left" }}
//           >
//             Education<span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssFormControl sx={{ width: "90%" }}>
//             <InputLabel>Select Education Details</InputLabel>
//             <CssSelect
//               multiple={true}
//               label="Select education details"
//               id="demo-simple-select-outlined"
//               size="small"
//               sx={{ width: "100%", 
//                 textAlign: "center", 
//                 mb: "2%" ,
//                 background:COLORS.primary,
//                }}
//               value={educationDetails}
//               onChange={(e) => setEduDetails(e.target.value)}
//             >
//               <MenuItem
//                 color="black"
//                 key="ug"
//                 value="ug"
//                 disabled={true}
//                 sx={{ color: COLORS.text, backgroundColor: "#033538" }}
//               >
//                 Under Graduate
//               </MenuItem>
//               {educationDetailsUg.map((degreeUg) => (
//                 <MenuItem
//                   key={degreeUg}
//                   value={degreeUg}
//                   sx={{ color: "black", }}
//                 >
//                   {degreeUg}
//                 </MenuItem>
//               ))}
//               <MenuItem
//                 key="pg"
//                 value="pg"
//                 disabled={true}
//                 sx={{ color: COLORS.text, backgroundColor: "#033538" }}
//               >
//                 Post Graduate
//               </MenuItem>
//               {educationDetailsPg.map((degreePg) => (
//                 <MenuItem
//                   key={degreePg}
//                   value={degreePg}
//                   sx={{ color: "black",  }}
//                 >
//                   {degreePg}
//                 </MenuItem>
//               ))}
//             </CssSelect>
//           </CssFormControl>
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//           display={isOthersUg === true ? "block" : "none"}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Educational Details (UG)
//           </Typography>
//           <CssTextField
//             label="Enter UG Educational Details"
//             id="custom-css-outlined-input"
//             size="small"
//             sx={{ width: "90%", mb: "2%" }}
//             value={ugDegree}
//             onChange={(e) => setUgDegree(e.target.value)}
//           />
//         </Box>

//         <br />
//         <br />

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//           display={isOthersPg === true ? "block" : "none"}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Educational Details (PG)
//           </Typography>
//           <CssTextField
//             label="Enter PG Educational Details"
//             id="custom-css-outlined-input"
//             size="small"
//             sx={{ width: "90%", mb: "2%" }}
//             value={pgDegree}
//             onChange={(e) => setPgDegree(e.target.value)}
//           />
//         </Box>

//         <Box
//           gridColumn="span 12"
//           sx={{ marginTop: "auto", textAlign: "right", width: "90%" }}
//         >
//           <Button
//             type="button"
//             className="btn btn-sm rounded-2 fw-medium"
//             onClick={clearForm}
//             sx={{
//               border: "1px solid",
//               color:  COLORS.button,
//                 "&:hover": {
//                   color: COLORS.hover_btn,
//                 },
//               width: "120px",
//               height: "35px",
//               borderRadius: "10px",
//               marginRight: "2%",
//             }}
//           >
//             Clear
//           </Button>

//           <Button
//             type="submit"
//             className="btn btn-sm rounded-2 fw-medium"
//             sx={{
//               // border: "1px solid",
//               background:  COLORS.button,
//                 "&:hover": {
//                   background: COLORS.hover_btn,
//                 },
//               color:COLORS.background,
//               width: "120px",
//               height: "35px",
//               borderRadius: "10px",
//             }}
//             onClick={(e) => saveJobDetails(e)}
//           >
//             Submit
//           </Button>
//         </Box>

//         <br />
//         <br />
//         <br />
//         <br />
//         <br />
//       </Box>
//     </div>
//   );
// };
// export default JobDescription;























































// import React, { useEffect } from "react";
// import Paper from "@mui/material/Paper";
// import Box from "@mui/material/Box";
// import { styled } from "@mui/material/styles";
// import { Button, TablePagination, ToggleButton } from "@mui/material";
// import Grid from "@mui/material/Grid";
// import Typography from "@mui/material/Typography";
// import TextField from "@mui/material/TextField";
// import FormGroup from "@mui/material/FormGroup";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import FormControl from "@mui/material/FormControl";
// import { useState } from "react";
// import Select, { SelectChangeEvent } from "@mui/material/Select";
// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
// import createInstance from "../../../api/axiosinstance";
// import Toast from "../../../utils/toast";
// import { useThemeMode } from "../../Themes/ThemeContextTemp.js";

// const Item = styled(Paper)(({ theme }) => ({
//   backgroundColor: theme.palette.mode === "dark" ? " #1A2027" : "#fff",
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: "center",
//   color: theme.palette.text.secondary,
// }));

// const JobDescription = () => {
//   const aiDishaApi = createInstance("DISHA");
//   const { COLORS } = useThemeMode();
  
//   // State Management
//   const [jobTitle, setJobTitle] = useState("");
//   const [yearsOfExpList, setYearsOfExpList] = useState([]);
//   const [yearsOfExperience, setYearsOfExperience] = useState("");
//   const [activeCities, setActiveCities] = useState([]);
//   const [city, setCity] = useState("");
//   const [state, setState] = useState("");
//   const [salaryRangeList, setSalaryRangeList] = useState([]);
//   const [salaryRange, setSalaryRange] = useState("");
//   const [employeeType, setEmployeeType] = useState("");
//   const [jobDescription, setJobDescription] = useState("");
//   const [responsibility, setResponsibility] = useState("");
//   const [activeSkills, setActiveSkills] = useState([]);
//   const [requiredSkills, setRequiredSkills] = useState([]);
//   const [additionalSkills, setAdditionalSkills] = useState("");
//   const [functionalArea, setFunctionalArea] = useState("");
//   const [designations, setDesignations] = useState([]);
//   const [designation, setDesignation] = useState("");
//   const [aboutCompany, setAboutCompany] = useState("");
//   const [educationDetails, setEducationDetails] = useState([]);
//   const [educationDetailsUg, setEducationDetailsUg] = useState([]);
//   const [educationDetailsPg, setEducationDetailsPg] = useState([]);
//   const [benefits, setBenefits] = useState("");
//   const [isOthersUg, setIsOthersUg] = useState(false);
//   const [isOthersPg, setIsOthersPg] = useState(false);
//   const [ugDegree, setUgDegree] = useState("");
//   const [pgDegree, setPgDegree] = useState("");

//   const organizationId = window.sessionStorage.getItem("organizationId");
//   console.log("ORGID" + organizationId);

//   // Create styled components inside component with access to COLORS
//   const CssTextField = styled(TextField)({
//     "& label": {
//       color: COLORS.text,
//     },
//     "& .MuiInput-underline:after": {
//       borderBottomColor: COLORS.border,
//     },
//     "& .MuiOutlinedInput-root": {
//       "& fieldset": {
//         borderColor: COLORS.border,
//         borderRadius: 10,
//       },
//       "&:hover fieldset": {
//         borderColor: COLORS.border,
//       },
//       "&.Mui-focused fieldset": {
//         borderColor: COLORS.border,
//       },
//       "& .MuiInputBase-input": {
//         color: COLORS.text,
//       },
//     },
//   });

//   const CssFormControl = styled(FormControl)({
//     "& label": {
//       color: COLORS.text,
//       "&.Mui-focused": {
//         color: COLORS.text,
//       },
//     },
//     "& .MuiInputBase-root": {
//       color: COLORS.text,
//       "& .MuiOutlinedInput-notchedOutline": {
//         borderColor: COLORS.border,
//         borderRadius: 10,
//       },
//       "&:hover .MuiOutlinedInput-notchedOutline": {
//         borderColor: COLORS.border,
//       },
//       "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//         borderColor: COLORS.border,
//       },
//     },
//   });

//   const CssSelect = styled(Select)({
//     "& .MuiSvgIcon-root": {
//       color: COLORS.text,
//       textAlign: "center",
//     },
//   });

//   useEffect(() => {
//     getActiveCities();
//     getActiveSkills();
//     getUgDetails();
//     getPgDetails();
//     getAllDropdownValues();
//   }, []);

//   const getAllDropdownValues = async () => {
//     await aiDishaApi
//       .get("/job_all_dropdown")
//       .then((response) => {
//         const values = response.data;
//         setYearsOfExpList(values["experience_yrs"]);
//         setSalaryRangeList(values["salary_range"]);
//         setDesignations(values["designation"]);
//         console.log(response.data);
//       })
//       .catch((error) => {
//         console.error(
//           "Error fetching the list of values for the drop downs",
//           error
//         );
//       });
//   };

//   const getActiveCities = async () => {
//     await aiDishaApi
//       .get("/Cities/active")
//       .then((response) => {
//         setActiveCities(response.data);
//         console.log(response.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching active cities" + error);
//       });
//   };

//   const getStateName = async (city) => {
//     setCity(city);
//     await aiDishaApi
//       .get(`/statenames_based_on_city?city=${city}`)
//       .then((response) => {
//         response.data.state ? setState(response.data.state) : setState("");
//         console.log("State is *********" + response.data.state);
//       })
//       .catch((error) => {
//         console.error("Error fetching state name for the given city", error);
//       });
//   };

//   const getActiveSkills = async () => {
//     await aiDishaApi
//       .get("/skills-show/active")
//       .then((response) => {
//         const skillData = response.data;
//         setActiveSkills(skillData);
//         console.log("skills values", skillData);
//         const skillNames = skillData.map((skill) => skill.skill_name);
//         console.log("All Skill Names:", skillNames);
//       })
//       .catch((error) => {
//         console.error("Error fetching active skills" + error);
//       });
//   };

//   const getUgDetails = async () => {
//     await aiDishaApi
//       .get("/undergraduate_degrees")
//       .then((response) => {
//         setEducationDetailsUg(response.data);
//         console.log(response.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching UG details" + error);
//       });
//   };

//   const getPgDetails = async () => {
//     await aiDishaApi
//       .get("/postgraduate_degrees")
//       .then((response) => {
//         setEducationDetailsPg(response.data);
//         console.log(response.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching PG details" + error);
//       });
//   };

//   const setEduDetails = (event) => {
//     console.log(event);
//     setEducationDetails(event);

//     setIsOthersUg(event.includes("Others(UG)") ? true : false);
//     setIsOthersPg(event.includes("Others(PG)") ? true : false);

//     console.log("UG others ? " + isOthersUg);
//     console.log("PG others ? " + isOthersPg);
//   };

//   const saveJobDetails = async (event) => {
//     event.preventDefault();

//     if (!jobTitle.trim()) {
//       console.error("Job title cannot be empty");
//       Toast.error("Job title cannot be empty");
//       return;
//     }

//     if (!yearsOfExperience.trim()) {
//       console.error("Experience cannot be empty");
//       Toast.error("Experience cannot be empty");
//       return;
//     }

//     if (!city.trim()) {
//       console.error("City cannot be empty");
//       Toast.error("City cannot be empty");
//       return;
//     }

//     if (!salaryRange.trim()) {
//       console.error("Salary Range be empty");
//       Toast.error("Salary Range cannot be empty");
//       return;
//     }

//     if (!employeeType.trim()) {
//       console.error("Employee Type be empty");
//       Toast.error("Employee Type cannot be empty");
//       return;
//     }

//     if (!jobDescription.trim()) {
//       console.error("Job Description be empty");
//       Toast.error("Job Description cannot be empty");
//       return;
//     }
//     if (!responsibility.trim()) {
//       console.error("Responsibility be empty");
//       Toast.error("Responsibility cannot be empty");
//       return;
//     }

//     if (requiredSkills.length === 0) {
//       console.error("Required Skills cannot be empty");
//       Toast.error("Required Skills cannot be empty");
//       return;
//     }

//     if (!aboutCompany.trim()) {
//       console.error("Company details cannot be empty");
//       Toast.error("Company details cannot be empty");
//       return;
//     }

//     if (!designation.trim()) {
//       console.error("Designation cannot be empty");
//       Toast.error("Designation cannot be empty");
//       return;
//     }

//     if (educationDetails.length === 0) {
//       console.error("Educational Details cannot be empty");
//       Toast.error("Educational Details cannot be empty");
//       return;
//     }

//     if (isOthersUg && !ugDegree.trim()) {
//       console.error("UG Details cannot be empty");
//       Toast.error("UG Details cannot be empty");
//       return;
//     }

//     if (isOthersPg && !pgDegree.trim()) {
//       console.error("PG Details cannot be empty");
//       Toast.error("PG Details cannot be empty");
//       return;
//     }

//     if (isOthersUg || isOthersPg) {
//       var ugIndex = educationDetails.indexOf("Others(UG)");
//       var pgIndex = educationDetails.indexOf("Others(UG)");
//       educationDetails.splice(ugIndex, 1);
//       educationDetails.splice(pgIndex, 1);

//       educationDetails.push(ugDegree);
//       educationDetails.push(pgDegree);
//     }

//     console.log(
//       "Title = " +
//         jobTitle +
//         "\n Exp = " +
//         yearsOfExperience +
//         "\n city = " +
//         city +
//         "\n state = " +
//         state +
//         "\n salary = " +
//         salaryRange +
//         "\n etype = " +
//         employeeType +
//         "\n jobdesc = " +
//         jobDescription +
//         "\n resp = " +
//         responsibility +
//         "\n req skills = " +
//         requiredSkills +
//         "\n add skills = " +
//         additionalSkills +
//         "\n funcArea = " +
//         functionalArea +
//         "\n designation = " +
//         designation +
//         "\n abt comp = " +
//         aboutCompany +
//         "\n benifits = " +
//         benefits +
//         "\n edu details = " +
//         educationDetails +
//         "\n ugDegree = " +
//         ugDegree +
//         "\n pgDegree = " +
//         pgDegree
//     );

//     await aiDishaApi
//       .post(
//         "/org-insert-job/",
//         {
//           org_id: organizationId,
//           job_title: jobTitle,
//           job_description: jobDescription,
//           company_info: aboutCompany,
//           responsibility: responsibility,
//           status: "Active",
//           additional_skills: additionalSkills,
//           benefits: benefits,
//         },
//         {
//           params: {
//             Education_Details: educationDetails,
//             Functional_area: functionalArea,
//             Required_Skills: requiredSkills,
//             city: city,
//             designation: designation,
//             emp_type: employeeType,
//             experience_yrs: yearsOfExperience,
//             salary_range: salaryRange,
//             state: state,
//           },
//           paramsSerializer: {
//             indexes: null,
//           },
//         }
//       )
//       .then((response) => {
//         console.log(response.data);
//         clearForm();
//         Toast.success("Job created successfully");
//       })
//       .catch((error) => {
//         console.error("Error creating job", error);
//       });
//   };

//   const clearForm = () => {
//     setJobTitle("");
//     setYearsOfExperience("");
//     setCity("");
//     setState("");
//     setSalaryRange("");
//     setEmployeeType("");
//     setJobDescription("");
//     setResponsibility("");
//     setRequiredSkills([]);
//     setAdditionalSkills("");
//     setFunctionalArea("");
//     setDesignation("");
//     setAboutCompany("");
//     setBenefits("");
//     setEducationDetails([]);
//   };

//   return (
//     <div
//       style={{
//         height: "calc(100% - 6%)",
//         overflow: "scroll",
//         overflowX: "hidden",
//         scrollbarWidth: "thin",
//         msOverflowStyle: "none",
//         scrollbarColor: "transparent transparent",
//         "&::-webkit-scrollbar": {
//           width: "5px",
//           height: "5px",
//         },
//       }}
//     >
//       <Box
//         display="grid"
//         gridTemplateColumns="repeat(12, 1fr)"
//         sx={{
//           marginTop: "auto",
//           alignItems: "center",
//           borderRadius: "10px",
//           padding: "1% 10%",
//         }}
//       >
//         <Box
//           gridColumn="span 12"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "0%" }}
//         >
//           <Typography
//             sx={{
//               fontFamily: "poppins",
//               fontSize: "28px",
//               color: COLORS.text,
//               mb: "2%",
//             }}
//           >
//             Add New Job
//           </Typography>
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Job Title<span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssTextField
//             label="Enter Job Title"
//             id="custom-css-outlined-input"
//             size="small"
//             sx={{ width: "90%", mb: "2%", background: COLORS.primary }}
//             value={jobTitle}
//             onChange={(e) => setJobTitle(e.target.value)}
//             required={true}
//             disabled={false}
//           />
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Experience(in Years)<span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssFormControl sx={{ width: "90%", color: "#FFFFFF" }}>
//             <InputLabel>Select Experience</InputLabel>
//             <CssSelect
//               label="Experience"
//               id="demo-simple-select-outlined"
//               size="small"
//               value={yearsOfExperience}
//               onChange={(e) => setYearsOfExperience(e.target.value)}
//               sx={{ width: "100%", textAlign: "center", background: COLORS.primary }}
//               required={true}
//               disabled={false}
//             >
//               <MenuItem
//                 key="yearsOfExp"
//                 value="yearsOfExp"
//                 disabled={true}
//                 sx={{ color: "black" }}
//               >
//                 Select Experience
//               </MenuItem>
//               {yearsOfExpList.map((exp) => (
//                 <MenuItem key={exp} value={exp} sx={{ color: "black" }}>
//                   {exp}
//                 </MenuItem>
//               ))}
//             </CssSelect>
//           </CssFormControl>
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             City<span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssFormControl sx={{ width: "90%" }}>
//             <InputLabel>Select city</InputLabel>
//             <CssSelect
//               label="City"
//               id="demo-simple-select-outlined"
//               size="small"
//               value={city}
//               onChange={(e) => getStateName(e.target.value)}
//               sx={{ width: "100%", textAlign: "center", background: COLORS.primary }}
//             >
//               {activeCities.map((city) => (
//                 <MenuItem key={city.city_name} value={city.city_name} sx={{ color: "black" }}>
//                   {city.city_name}
//                 </MenuItem>
//               ))}
//             </CssSelect>
//           </CssFormControl>
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             State
//           </Typography>

//           <CssTextField
//             id="custom-css-outlined-input"
//             size="small"
//             sx={{ width: "90%", mb: "2%", background: COLORS.primary }}
//             value={state}
//             disabled={true}
//           />
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Salary Range<span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssFormControl sx={{ width: "90%" }}>
//             <InputLabel>Select Salary Range</InputLabel>
//             <CssSelect
//               label="Salary Range"
//               id="demo-simple-select-outlined"
//               size="small"
//               value={salaryRange}
//               onChange={(e) => setSalaryRange(e.target.value)}
//               sx={{ width: "100%", textAlign: "center", background: COLORS.primary }}
//               required={true}
//               disabled={false}
//             >
//               <MenuItem
//                 key="salaryrange"
//                 value="salaryRange"
//                 disabled={true}
//                 sx={{ color: "black" }}
//               >
//                 Select Salary Range
//               </MenuItem>
//               {salaryRangeList.map((sal) => (
//                 <MenuItem key={sal} value={sal} sx={{ color: "black" }}>
//                   {sal}
//                 </MenuItem>
//               ))}
//             </CssSelect>
//           </CssFormControl>
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{
//             marginTop: "auto",
//             textAlign: "left",
//             width: "90%",
//             marginBottom: "2%",
//           }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Employee Type<span style={{ color: "red" }}>*</span>
//           </Typography>

//           <ToggleButtonGroup 
//           color="primary" 
//           value={employeeType} 
//           exclusive
//           onChange={(e, newValue) => {
//                if (newValue !== null) setEmployeeType(newValue);
//              }}>
//             <ToggleButton
//               style={{
//                 border: "1px solid",
//                 borderColor: "#B9B9B9",
//                 borderRadius: "10px",
//                 color: COLORS.text,
//                 background: COLORS.primary,
//                 fontFamily: "poppins",
//                 fontSize: "12px",
//                  "&.Mui-selected": {
//                 backgroundColor: "#d3dbdfc3",
//                 color: "#000",
//                 },

//                 "&.Mui-selected:hover": {
//                   backgroundColor: "#d3dbdfc3",
//                 },
//               }}
//               value="Full Time"
//               onClick={(e) => setEmployeeType(e.target.value)}
//             >
//               Full Time
//             </ToggleButton>
//             <ToggleButton
//               selectedColor="#ffffffe8"
//               style={{
//                 border: "1px solid",
//                 borderColor: "#B9B9B9",
//                 borderRadius: "10px",
//                 color: COLORS.text,
//                 background: COLORS.primary,
//                 fontFamily: "poppins",
//                 fontSize: "12px",
//                  "&.Mui-selected": {
//         backgroundColor: "#d3dbdfc3",
//         color: "#000",
//       },
//               }}
//               value="Part Time"
//               onClick={(e) => setEmployeeType(e.target.value)}
//             >
//               Part Time
//             </ToggleButton>
//             <ToggleButton
//               selectedColor="#FFFFFF"
//               style={{
//                 border: "1px solid",
//                 borderColor: "#B9B9B9",
//                 borderRadius: "10px",
//                 color: COLORS.text,
//                 background: COLORS.primary,
//                 fontFamily: "poppins",
//                 fontSize: "12px",
//                  "&.Mui-selected": {
//         backgroundColor: "#d3dbdfc3",
//         color: "#000",
//       },
//               }}
//               value="Contract"
//               onClick={(e) => setEmployeeType(e.target.value)}
//             >
//               Contract
//             </ToggleButton>
//             <ToggleButton
//               selectedColor="#FFFFFF"
//               style={{
//                 border: "1px solid",
//                 borderColor: "#B9B9B9",
//                 borderRadius: "10px",
//                 color: COLORS.text,
//                 background: COLORS.primary,
//                 fontFamily: "poppins",
//                 fontSize: "12px",
//                  "&.Mui-selected": {
//         backgroundColor: "#d3dbdfc3",
//         color: "#000",
//       },
//               }}
//               value="Internship"
//               onClick={(e) => setEmployeeType(e.target.value)}
//             >
//               Internship
//             </ToggleButton>
//           </ToggleButtonGroup>
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", width: "90%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Job Description
//             <span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssTextField
//             id="outlined-multiline-flexible"
//             label="Enter Job Description"
//             multiline
//             rows={2}
//             sx={{ width: "100%", mb: "2%", background: COLORS.primary }}
//             value={jobDescription}
//             onChange={(e) => setJobDescription(e.target.value)}
//           />
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", width: "90%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Responsibility
//             <span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssTextField
//             id="outlined-multiline-flexible"
//             label="Enter Responsibilities"
//             multiline
//             rows={2}
//             sx={{ width: "100%", mb: "2%", background: COLORS.primary }}
//             value={responsibility}
//             onChange={(e) => setResponsibility(e.target.value)}
//           />
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Required Skills
//             <span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssFormControl sx={{ width: "90%" }}>
//             <InputLabel>Select Skills</InputLabel>
//             <CssSelect
//               multiple={true}
//               label="Select Type of Sector"
//               id="demo-simple-select-outlined"
//               size="small"
//               sx={{ width: "100%", textAlign: "center", mb: "2%", background: COLORS.primary }}
//               value={requiredSkills}
//               onChange={(e) => setRequiredSkills(e.target.value)}
//             >
//               {(activeSkills || []).map((skill, index) => (
//                 <MenuItem key={skill.skill_name} value={skill.skill_name} sx={{ color: "black" }}>
//                   {skill.skill_name}
//                 </MenuItem>
//               ))}
//             </CssSelect>
//           </CssFormControl>
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Additional Skills
//           </Typography>
//           <CssTextField
//             label="Enter Additional Skills"
//             id="custom-css-outlined-input"
//             size="small"
//             sx={{ width: "90%", mb: "2%", background: COLORS.primary }}
//             value={additionalSkills}
//             onChange={(e) => setAdditionalSkills(e.target.value)}
//           />
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Functional Area
//           </Typography>
//           <CssTextField
//             label="Enter Functional Area"
//             id="custom-css-outlined-input"
//             size="small"
//             sx={{ width: "90%", mb: "2%", background: COLORS.primary }}
//             value={functionalArea}
//             onChange={(e) => setFunctionalArea(e.target.value)}
//           />
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Designation<span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssFormControl sx={{ width: "90%" }}>
//             <InputLabel>Select Designation</InputLabel>
//             <CssSelect
//               label="Select Role"
//               id="demo-simple-select-outlined"
//               size="small"
//               sx={{ width: "100%", textAlign: "center", mb: "2%", background: COLORS.primary }}
//               value={designation}
//               onChange={(e) => setDesignation(e.target.value)}
//             >
//               <MenuItem
//                 key="designation"
//                 value="designation"
//                 disabled={true}
//                 sx={{ color: "black" }}
//               >
//                 Select Designation
//               </MenuItem>
//               {designations.map((desig) => (
//                 <MenuItem key={desig} value={desig} sx={{ color: "black" }}>
//                   {desig}
//                 </MenuItem>
//               ))}
//             </CssSelect>
//           </CssFormControl>
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{
//             marginTop: "auto",
//             textAlign: "left",
//             width: "90%",
//             marginBottom: "2%",
//           }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             About the Company<span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssTextField
//             id="outlined-multiline-flexible"
//             label="Enter details about the company"
//             multiline
//             rows={2}
//             sx={{ width: "100%", mb: "2%", background: COLORS.primary }}
//             value={aboutCompany}
//             onChange={(e) => setAboutCompany(e.target.value)}
//           />
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{
//             marginTop: "auto",
//             textAlign: "left",
//             width: "90%",
//             marginBottom: "2%",
//           }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Benefits
//           </Typography>
//           <CssTextField
//             id="outlined-multiline-flexible"
//             label="Enter Benefits"
//             multiline
//             rows={2}
//             sx={{ width: "100%", mb: "2%", background: COLORS.primary }}
//             value={benefits}
//             onChange={(e) => setBenefits(e.target.value)}
//           />
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Education<span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssFormControl sx={{ width: "90%" }}>
//             <InputLabel>Select Education Details</InputLabel>
//             <CssSelect
//               multiple={true}
//               label="Select education details"
//               id="demo-simple-select-outlined"
//               size="small"
//               sx={{
//                 width: "100%",
//                 textAlign: "center",
//                 mb: "2%",
//                 background: COLORS.primary,
//               }}
//               value={educationDetails}
//               onChange={(e) => setEduDetails(e.target.value)}
//             >
//               <MenuItem
//                 color="black"
//                 key="ug"
//                 value="ug"
//                 disabled={true}
//                 sx={{ color: COLORS.text, backgroundColor: "#033538" }}
//               >
//                 Under Graduate
//               </MenuItem>
//               {educationDetailsUg.map((degreeUg) => (
//                 <MenuItem key={degreeUg} value={degreeUg} sx={{ color: "black" }}>
//                   {degreeUg}
//                 </MenuItem>
//               ))}
//               <MenuItem
//                 key="pg"
//                 value="pg"
//                 disabled={true}
//                 sx={{ color: COLORS.text, backgroundColor: "#033538" }}
//               >
//                 Post Graduate
//               </MenuItem>
//               {educationDetailsPg.map((degreePg) => (
//                 <MenuItem key={degreePg} value={degreePg} sx={{ color: "black" }}>
//                   {degreePg}
//                 </MenuItem>
//               ))}
//             </CssSelect>
//           </CssFormControl>
//         </Box>

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//           display={isOthersUg === true ? "block" : "none"}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Educational Details (UG)
//           </Typography>
//           <CssTextField
//             label="Enter UG Educational Details"
//             id="custom-css-outlined-input"
//             size="small"
//             sx={{ width: "90%", mb: "2%", background: COLORS.primary }}
//             value={ugDegree}
//             onChange={(e) => setUgDegree(e.target.value)}
//           />
//         </Box>

//         <br />
//         <br />

//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//           display={isOthersPg === true ? "block" : "none"}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Educational Details (PG)
//           </Typography>
//           <CssTextField
//             label="Enter PG Educational Details"
//             id="custom-css-outlined-input"
//             size="small"
//             sx={{ width: "90%", mb: "2%", background: COLORS.primary }}
//             value={pgDegree}
//             onChange={(e) => setPgDegree(e.target.value)}
//           />
//         </Box>

//         <Box
//           gridColumn="span 12"
//           sx={{ marginTop: "auto", textAlign: "right", width: "90%" }}
//         >
//           <Button
//             type="button"
//             className="btn btn-sm rounded-2 fw-medium"
//             onClick={clearForm}
//             sx={{
//               border: "1px solid",
//               color: COLORS.button,
//               "&:hover": {
//                 color: COLORS.hover_btn,
//               },
//               width: "120px",
//               height: "35px",
//               borderRadius: "10px",
//               marginRight: "2%",
//             }}
//           >
//             Clear
//           </Button>

//           <Button
//             type="submit"
//             className="btn btn-sm rounded-2 fw-medium"
//             sx={{
//               background: COLORS.button,
//               "&:hover": {
//                 background: COLORS.hover_btn,
//               },
//               color: COLORS.background,
//               width: "120px",
//               height: "35px",
//               borderRadius: "10px",
//             }}
//             onClick={(e) => saveJobDetails(e)}
//           >
//             Submit
//           </Button>
//         </Box>

//         <br />
//         <br />
//         <br />
//         <br />
//         <br />
//       </Box>
//     </div>
//   );
// };

// export default JobDescription;



































































import React, { useEffect } from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { Button, TablePagination, ToggleButton } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { useState } from "react";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import createInstance from "../../../api/axiosinstance";
import Toast from "../../../utils/toast";
import { useThemeMode } from "../../Themes/ThemeContextTemp.js";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? " #1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const JobDescription = () => {
  const aiDishaApi = createInstance("DISHA");
  const { COLORS } = useThemeMode();
  
  // State Management
  const [jobTitle, setJobTitle] = useState("");
  const [yearsOfExpList, setYearsOfExpList] = useState([]);
  const [yearsOfExperience, setYearsOfExperience] = useState("");
  const [activeCities, setActiveCities] = useState([]);
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [salaryRangeList, setSalaryRangeList] = useState([]);
  const [salaryRange, setSalaryRange] = useState("");
  const [employeeType, setEmployeeType] = useState("");
  const [jobDescription, setJobDescription] = useState("");
  const [responsibility, setResponsibility] = useState("");
  const [activeSkills, setActiveSkills] = useState([]);
  const [requiredSkills, setRequiredSkills] = useState([]);
  const [additionalSkills, setAdditionalSkills] = useState("");
  const [functionalArea, setFunctionalArea] = useState("");
  const [designations, setDesignations] = useState([]);
  const [designation, setDesignation] = useState("");
  const [aboutCompany, setAboutCompany] = useState("");
  const [educationDetails, setEducationDetails] = useState([]);
  const [educationDetailsUg, setEducationDetailsUg] = useState([]);
  const [educationDetailsPg, setEducationDetailsPg] = useState([]);
  const [benefits, setBenefits] = useState("");
  const [isOthersUg, setIsOthersUg] = useState(false);
  const [isOthersPg, setIsOthersPg] = useState(false);
  const [ugDegree, setUgDegree] = useState("");
  const [pgDegree, setPgDegree] = useState("");

  const organizationId = window.sessionStorage.getItem("organizationId");
  console.log("ORGID" + organizationId);

  // Create styled components inside component with access to COLORS
  const CssTextField = styled(TextField)({
    "& label": {
      color: COLORS.text,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: COLORS.border,
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: COLORS.border,
        borderRadius: 10,
      },
      "&:hover fieldset": {
        borderColor: COLORS.border,
      },
      "&.Mui-focused fieldset": {
        borderColor: COLORS.border,
      },
      "& .MuiInputBase-input": {
        color: COLORS.text,
      },
    },
  });

  const CssFormControl = styled(FormControl)({
    "& label": {
      color: COLORS.text,
      "&.Mui-focused": {
        color: COLORS.text,
      },
    },
    "& .MuiInputBase-root": {
      color: COLORS.text,
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: COLORS.border,
        borderRadius: 10,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: COLORS.border,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: COLORS.border,
      },
    },
  });

  const CssSelect = styled(Select)({
    "& .MuiSvgIcon-root": {
      color: COLORS.text,
      textAlign: "center",
    },
  });

  useEffect(() => {
    getActiveCities();
    getActiveSkills();
    getUgDetails();
    getPgDetails();
    getAllDropdownValues();
  }, []);

  const getAllDropdownValues = async () => {
    await aiDishaApi
      .get("/job_all_dropdown")
      .then((response) => {
        const values = response.data;
        setYearsOfExpList(values["experience_yrs"]);
        setSalaryRangeList(values["salary_range"]);
        setDesignations(values["designation"]);
        console.log(response.data);
      })
      .catch((error) => {
        console.error(
          "Error fetching the list of values for the drop downs",
          error
        );
      });
  };

  const getActiveCities = async () => {
    await aiDishaApi
      .get("/Cities/active")
      .then((response) => {
        setActiveCities(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error fetching active cities" + error);
      });
  };

  const getStateName = async (city) => {
    setCity(city);
    await aiDishaApi
      .get(`/statenames_based_on_city?city=${city}`)
      .then((response) => {
        response.data.state ? setState(response.data.state) : setState("");
        console.log("State is *********" + response.data.state);
      })
      .catch((error) => {
        console.error("Error fetching state name for the given city", error);
      });
  };

  const getActiveSkills = async () => {
    await aiDishaApi
      .get("/skills-show/active")
      .then((response) => {
        const skillData = response.data;
        setActiveSkills(skillData);
        console.log("skills values", skillData);
        const skillNames = skillData.map((skill) => skill.skill_name);
        console.log("All Skill Names:", skillNames);
      })
      .catch((error) => {
        console.error("Error fetching active skills" + error);
      });
  };

  const getUgDetails = async () => {
    await aiDishaApi
      .get("/undergraduate_degrees")
      .then((response) => {
        setEducationDetailsUg(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error fetching UG details" + error);
      });
  };

  const getPgDetails = async () => {
    await aiDishaApi
      .get("/postgraduate_degrees")
      .then((response) => {
        setEducationDetailsPg(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error fetching PG details" + error);
      });
  };

  const setEduDetails = (event) => {
    console.log(event);
    setEducationDetails(event);

    setIsOthersUg(event.includes("Others(UG)") ? true : false);
    setIsOthersPg(event.includes("Others(PG)") ? true : false);

    console.log("UG others ? " + isOthersUg);
    console.log("PG others ? " + isOthersPg);
  };

  const saveJobDetails = async (event) => {
    event.preventDefault();

    if (!jobTitle.trim()) {
      console.error("Job title cannot be empty");
      Toast.error("Job title cannot be empty");
      return;
    }

    if (!yearsOfExperience.trim()) {
      console.error("Experience cannot be empty");
      Toast.error("Experience cannot be empty");
      return;
    }

    if (!city.trim()) {
      console.error("City cannot be empty");
      Toast.error("City cannot be empty");
      return;
    }

    if (!salaryRange.trim()) {
      console.error("Salary Range be empty");
      Toast.error("Salary Range cannot be empty");
      return;
    }

    if (!employeeType.trim()) {
      console.error("Employee Type be empty");
      Toast.error("Employee Type cannot be empty");
      return;
    }

    if (!jobDescription.trim()) {
      console.error("Job Description be empty");
      Toast.error("Job Description cannot be empty");
      return;
    }
    if (!responsibility.trim()) {
      console.error("Responsibility be empty");
      Toast.error("Responsibility cannot be empty");
      return;
    }

    if (requiredSkills.length === 0) {
      console.error("Required Skills cannot be empty");
      Toast.error("Required Skills cannot be empty");
      return;
    }

    if (!aboutCompany.trim()) {
      console.error("Company details cannot be empty");
      Toast.error("Company details cannot be empty");
      return;
    }

    if (!designation.trim()) {
      console.error("Designation cannot be empty");
      Toast.error("Designation cannot be empty");
      return;
    }

    if (educationDetails.length === 0) {
      console.error("Educational Details cannot be empty");
      Toast.error("Educational Details cannot be empty");
      return;
    }

    if (isOthersUg && !ugDegree.trim()) {
      console.error("UG Details cannot be empty");
      Toast.error("UG Details cannot be empty");
      return;
    }

    if (isOthersPg && !pgDegree.trim()) {
      console.error("PG Details cannot be empty");
      Toast.error("PG Details cannot be empty");
      return;
    }

    if (isOthersUg || isOthersPg) {
      var ugIndex = educationDetails.indexOf("Others(UG)");
      var pgIndex = educationDetails.indexOf("Others(UG)");
      educationDetails.splice(ugIndex, 1);
      educationDetails.splice(pgIndex, 1);

      educationDetails.push(ugDegree);
      educationDetails.push(pgDegree);
    }

    console.log(
      "Title = " +
        jobTitle +
        "\n Exp = " +
        yearsOfExperience +
        "\n city = " +
        city +
        "\n state = " +
        state +
        "\n salary = " +
        salaryRange +
        "\n etype = " +
        employeeType +
        "\n jobdesc = " +
        jobDescription +
        "\n resp = " +
        responsibility +
        "\n req skills = " +
        requiredSkills +
        "\n add skills = " +
        additionalSkills +
        "\n funcArea = " +
        functionalArea +
        "\n designation = " +
        designation +
        "\n abt comp = " +
        aboutCompany +
        "\n benifits = " +
        benefits +
        "\n edu details = " +
        educationDetails +
        "\n ugDegree = " +
        ugDegree +
        "\n pgDegree = " +
        pgDegree
    );

    await aiDishaApi
      .post(
        "/org-insert-job/",
        {
          org_id: organizationId,
          job_title: jobTitle,
          job_description: jobDescription,
          company_info: aboutCompany,
          responsibility: responsibility,
          status: "Active",
          additional_skills: additionalSkills,
          benefits: benefits,
        },
        {
          params: {
            Education_Details: educationDetails,
            Functional_area: functionalArea,
            Required_Skills: requiredSkills,
            city: city,
            designation: designation,
            emp_type: employeeType,
            experience_yrs: yearsOfExperience,
            salary_range: salaryRange,
            state: state,
          },
          paramsSerializer: {
            indexes: null,
          },
        }
      )
      .then((response) => {
        console.log(response.data);
        clearForm();
        Toast.success("Job created successfully");
      })
      .catch((error) => {
        console.error("Error creating job", error);
      });
  };

  const clearForm = () => {
    setJobTitle("");
    setYearsOfExperience("");
    setCity("");
    setState("");
    setSalaryRange("");
    setEmployeeType("");
    setJobDescription("");
    setResponsibility("");
    setRequiredSkills([]);
    setAdditionalSkills("");
    setFunctionalArea("");
    setDesignation("");
    setAboutCompany("");
    setBenefits("");
    setEducationDetails([]);
  };

  return (
    <div
      style={{
        height: "calc(100% - 6%)",
        overflow: "scroll",
        overflowX: "hidden",
        scrollbarWidth: "thin",
        msOverflowStyle: "none",
        scrollbarColor: "transparent transparent",
        "&::-webkit-scrollbar": {
          width: "5px",
          height: "5px",
        },
      }}
    >
      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        sx={{
          marginTop: "auto",
          alignItems: "center",
          borderRadius: "10px",
          padding: "1% 10%",
        }}
      >
        <Box
          gridColumn="span 12"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "0%" }}
        >
          <Typography
            sx={{
              fontFamily: "poppins",
              fontSize: "28px",
              color: COLORS.text,
              mb: "2%",
            }}
          >
            Add New Job
          </Typography>
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
          >
            Job Title<span style={{ color: "red" }}>*</span>
          </Typography>
          <CssTextField
            label="Enter Job Title"
            id="custom-css-outlined-input"
            size="small"
            sx={{ width: "90%", mb: "2%", background: COLORS.primary }}
            value={jobTitle}
            onChange={(e) => setJobTitle(e.target.value)}
            required={true}
            disabled={false}
          />
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
          >
            Experience(in Years)<span style={{ color: "red" }}>*</span>
          </Typography>
          <CssFormControl sx={{ width: "90%", color: "#FFFFFF" }}>
            <InputLabel>Select Experience</InputLabel>
            <CssSelect
              label="Experience"
              id="demo-simple-select-outlined"
              size="small"
              value={yearsOfExperience}
              onChange={(e) => setYearsOfExperience(e.target.value)}
              sx={{ width: "100%", textAlign: "center", background: COLORS.primary }}
              required={true}
              disabled={false}
            >
              <MenuItem
                key="yearsOfExp"
                value="yearsOfExp"
                disabled={true}
                sx={{ color: "black" }}
              >
                Select Experience
              </MenuItem>
              {yearsOfExpList.map((exp) => (
                <MenuItem key={exp} value={exp} sx={{ color: "black" }}>
                  {exp}
                </MenuItem>
              ))}
            </CssSelect>
          </CssFormControl>
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
          >
            City<span style={{ color: "red" }}>*</span>
          </Typography>
          <CssFormControl sx={{ width: "90%" }}>
            <InputLabel>Select city</InputLabel>
            <CssSelect
              label="City"
              id="demo-simple-select-outlined"
              size="small"
              value={city}
              onChange={(e) => getStateName(e.target.value)}
              sx={{ width: "100%", textAlign: "center", background: COLORS.primary }}
            >
              {activeCities.map((city) => (
                <MenuItem key={city.city_name} value={city.city_name} sx={{ color: "black" }}>
                  {city.city_name}
                </MenuItem>
              ))}
            </CssSelect>
          </CssFormControl>
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
          >
            State
          </Typography>

          <CssTextField
            id="custom-css-outlined-input"
            size="small"
            sx={{ width: "90%", mb: "2%", background: COLORS.primary }}
            value={state}
            disabled={true}
          />
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
          >
            Salary Range<span style={{ color: "red" }}>*</span>
          </Typography>
          <CssFormControl sx={{ width: "90%" }}>
            <InputLabel>Select Salary Range</InputLabel>
            <CssSelect
              label="Salary Range"
              id="demo-simple-select-outlined"
              size="small"
              value={salaryRange}
              onChange={(e) => setSalaryRange(e.target.value)}
              sx={{ 
                width: "100%", 
                textAlign: "center", 
                background: COLORS.primary,
                "& .MuiOutlinedInput-input": {
                  color: COLORS.text,
                },
              }}
              required={true}
              disabled={false}
            >
              <MenuItem
                key="salaryrange"
                value="salaryRange"
                disabled={true}
                sx={{ color: "black" }}
              >
                Select Salary Range
              </MenuItem>
              {salaryRangeList.map((sal) => (
                <MenuItem 
                  key={sal} 
                  value={sal} 
                  sx={{ 
                    color: "black",
                    backgroundColor: salaryRange === sal ? COLORS.accent : "transparent",
                    "&:hover": {
                      backgroundColor: COLORS.accent,
                    },
                    fontWeight: salaryRange === sal ? 600 : 400,
                  }}
                >
                  {sal}
                </MenuItem>
              ))}
            </CssSelect>
          </CssFormControl>
        </Box>

        <Box
          gridColumn="span 6"
          sx={{
            marginTop: "auto",
            textAlign: "left",
            width: "90%",
            marginBottom: "2%",
          }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
          >
            Employee Type<span style={{ color: "red" }}>*</span>
          </Typography>
          <ToggleButtonGroup
  value={employeeType}
  exclusive
  onChange={(e, newValue) => {
    if (newValue !== null) setEmployeeType(newValue);
  }}
  sx={{
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)", // 3 buttons per row
    gap: "10px",
    width: "100%",
  }}
>
  {["Full Time", "Part Time", "Contract", "Internship"].map((type) => (
    <ToggleButton
      key={type}
      value={type}
      sx={{
        border: `2px solid ${COLORS.border}`,
        borderRadius: "12px",
        color: employeeType === type ? COLORS.background : COLORS.text,
        backgroundColor:
          employeeType === type ? COLORS.accent : COLORS.primary,
        fontFamily: "poppins",
        fontSize: "13px",
        padding: "10px",
        fontWeight: employeeType === type ? 600 : 500,
        transition: "all 0.3s ease",
        textTransform: "none",

        "&:hover": {
          backgroundColor: COLORS.accent,
          color: COLORS.background,
        },

        height: "45px", // fixed height = perfect alignment
      }}
    >
      {type}
    </ToggleButton>
  ))}
</ToggleButtonGroup>


          {/* <ToggleButtonGroup 
            color="primary" 
            value={employeeType} 
            exclusive
            sx={{
              display: "flex",
              gridTemplateColumns: "repeat(4, 1fr) !important",
              gap: "8px",
              flexWrap: "wrap",
            }}
          >
            <ToggleButton
              value="Full Time"
              onClick={(e) => setEmployeeType(e.currentTarget.value)}
              sx={{
                border: `2px solid ${COLORS.border}`,
                borderRadius: "10px",
                color: employeeType === "Full Time" ? COLORS.background : COLORS.text,
                backgroundColor: employeeType === "Full Time" ? COLORS.accent : COLORS.primary,
                fontFamily: "poppins",
                fontSize: "12px",
                padding: "8px 16px",
                fontWeight: employeeType === "Full Time" ? 600 : 500,
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: COLORS.accent,
                  color: COLORS.background,
                },
                flex: 1,
                minWidth: "100px",
              }}
            >
              Full Time
            </ToggleButton>
            <ToggleButton
              value="Part Time"
              onClick={(e) => setEmployeeType(e.currentTarget.value)}
              sx={{
                border: `2px solid ${COLORS.border}`,
                borderRadius: 2,
                color: employeeType === "Part Time" ? COLORS.background : COLORS.text,
                backgroundColor: employeeType === "Part Time" ? COLORS.accent : COLORS.primary,
                fontFamily: "poppins",
                fontSize: "12px",
                padding: "8px 16px",
                fontWeight: employeeType === "Part Time" ? 600 : 500,
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: COLORS.accent,
                  color: COLORS.background,
                },
                flex: 1,
                minWidth: "100px",
              }}
            >
              Part Time
            </ToggleButton>
            <ToggleButton
              value="Contract"
              onClick={(e) => setEmployeeType(e.currentTarget.value)}
              sx={{
                border: `2px solid ${COLORS.border}`,
                borderRadius: "10px",
                color: employeeType === "Contract" ? COLORS.background : COLORS.text,
                backgroundColor: employeeType === "Contract" ? COLORS.accent : COLORS.primary,
                fontFamily: "poppins",
                fontSize: "12px",
                padding: "8px 16px",
                fontWeight: employeeType === "Contract" ? 600 : 500,
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: COLORS.accent,
                  color: COLORS.background,
                },
                flex: 1,
                minWidth: "100px",
              }}
            >
              Contract
            </ToggleButton>
            <ToggleButton
              value="Internship"
              onClick={(e) => setEmployeeType(e.currentTarget.value)}
              sx={{
                border: `2px solid ${COLORS.border}`,
                borderRadius: "10px",
                color: employeeType === "Internship" ? COLORS.background : COLORS.text,
                backgroundColor: employeeType === "Internship" ? COLORS.accent : COLORS.primary,
                fontFamily: "poppins",
                fontSize: "12px",
                padding: "8px 16px",
                fontWeight: employeeType === "Internship" ? 600 : 500,
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: COLORS.accent,
                  color: COLORS.background,
                },
                flex: 1,
                minWidth: "100px",
              }}
            >
              Internship
            </ToggleButton>
          </ToggleButtonGroup> */}
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", width: "90%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
          >
            Job Description
            <span style={{ color: "red" }}>*</span>
          </Typography>
          <CssTextField
            id="outlined-multiline-flexible"
            label="Enter Job Description"
            multiline
            rows={2}
            sx={{ width: "100%", mb: "2%", background: COLORS.primary }}
            value={jobDescription}
            onChange={(e) => setJobDescription(e.target.value)}
          />
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", width: "90%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
          >
            Responsibility
            <span style={{ color: "red" }}>*</span>
          </Typography>
          <CssTextField
            id="outlined-multiline-flexible"
            label="Enter Responsibilities"
            multiline
            rows={2}
            sx={{ width: "100%", mb: "2%", background: COLORS.primary }}
            value={responsibility}
            onChange={(e) => setResponsibility(e.target.value)}
          />
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
          >
            Required Skills
            <span style={{ color: "red" }}>*</span>
          </Typography>
          <CssFormControl sx={{ width: "90%" }}>
            <InputLabel>Select Skills</InputLabel>
            <CssSelect
              multiple={true}
              label="Select Type of Sector"
              id="demo-simple-select-outlined"
              size="small"
              sx={{ width: "100%", textAlign: "center", mb: "2%", background: COLORS.primary }}
              value={requiredSkills}
              onChange={(e) => setRequiredSkills(e.target.value)}
            >
              {(activeSkills || []).map((skill, index) => (
                <MenuItem key={skill.skill_name} value={skill.skill_name} sx={{ color: "black" }}>
                  {skill.skill_name}
                </MenuItem>
              ))}
            </CssSelect>
          </CssFormControl>
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
          >
            Additional Skills
          </Typography>
          <CssTextField
            label="Enter Additional Skills"
            id="custom-css-outlined-input"
            size="small"
            sx={{ width: "90%", mb: "2%", background: COLORS.primary }}
            value={additionalSkills}
            onChange={(e) => setAdditionalSkills(e.target.value)}
          />
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
          >
            Functional Area
          </Typography>
          <CssTextField
            label="Enter Functional Area"
            id="custom-css-outlined-input"
            size="small"
            sx={{ width: "90%", mb: "2%", background: COLORS.primary }}
            value={functionalArea}
            onChange={(e) => setFunctionalArea(e.target.value)}
          />
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
          >
            Designation<span style={{ color: "red" }}>*</span>
          </Typography>
          <CssFormControl sx={{ width: "90%" }}>
            <InputLabel>Select Designation</InputLabel>
            <CssSelect
              label="Select Role"
              id="demo-simple-select-outlined"
              size="small"
              sx={{ width: "100%", textAlign: "center", mb: "2%", background: COLORS.primary }}
              value={designation}
              onChange={(e) => setDesignation(e.target.value)}
            >
              <MenuItem
                key="designation"
                value="designation"
                disabled={true}
                sx={{ color: "black" }}
              >
                Select Designation
              </MenuItem>
              {designations.map((desig) => (
                <MenuItem key={desig} value={desig} sx={{ color: "black" }}>
                  {desig}
                </MenuItem>
              ))}
            </CssSelect>
          </CssFormControl>
        </Box>

        <Box
          gridColumn="span 6"
          sx={{
            marginTop: "auto",
            textAlign: "left",
            width: "90%",
            marginBottom: "2%",
          }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
          >
            About the Company<span style={{ color: "red" }}>*</span>
          </Typography>
          <CssTextField
            id="outlined-multiline-flexible"
            label="Enter details about the company"
            multiline
            rows={2}
            sx={{ width: "100%", mb: "2%", background: COLORS.primary }}
            value={aboutCompany}
            onChange={(e) => setAboutCompany(e.target.value)}
          />
        </Box>

        <Box
          gridColumn="span 6"
          sx={{
            marginTop: "auto",
            textAlign: "left",
            width: "90%",
            marginBottom: "2%",
          }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
          >
            Benefits
          </Typography>
          <CssTextField
            id="outlined-multiline-flexible"
            label="Enter Benefits"
            multiline
            rows={2}
            sx={{ width: "100%", mb: "2%", background: COLORS.primary }}
            value={benefits}
            onChange={(e) => setBenefits(e.target.value)}
          />
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
          >
            Education<span style={{ color: "red" }}>*</span>
          </Typography>
          <CssFormControl sx={{ width: "90%" }}>
            <InputLabel>Select Education Details</InputLabel>
            <CssSelect
              multiple={true}
              label="Select education details"
              id="demo-simple-select-outlined"
              size="small"
              sx={{
                width: "100%",
                textAlign: "center",
                mb: "2%",
                background: COLORS.primary,
              }}
              value={educationDetails}
              onChange={(e) => setEduDetails(e.target.value)}
            >
              <MenuItem
                color="black"
                key="ug"
                value="ug"
                disabled={true}
                sx={{ color: COLORS.text, backgroundColor: "#033538" }}
              >
                Under Graduate
              </MenuItem>
              {educationDetailsUg.map((degreeUg) => (
                <MenuItem key={degreeUg} value={degreeUg} sx={{ color: "black" }}>
                  {degreeUg}
                </MenuItem>
              ))}
              <MenuItem
                key="pg"
                value="pg"
                disabled={true}
                sx={{ color: COLORS.text, backgroundColor: "#033538" }}
              >
                Post Graduate
              </MenuItem>
              {educationDetailsPg.map((degreePg) => (
                <MenuItem key={degreePg} value={degreePg} sx={{ color: "black" }}>
                  {degreePg}
                </MenuItem>
              ))}
            </CssSelect>
          </CssFormControl>
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
          display={isOthersUg === true ? "block" : "none"}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
          >
            Educational Details (UG)
          </Typography>
          <CssTextField
            label="Enter UG Educational Details"
            id="custom-css-outlined-input"
            size="small"
            sx={{ width: "90%", mb: "2%", background: COLORS.primary }}
            value={ugDegree}
            onChange={(e) => setUgDegree(e.target.value)}
          />
        </Box>

        <br />
        <br />

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
          display={isOthersPg === true ? "block" : "none"}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
          >
            Educational Details (PG)
          </Typography>
          <CssTextField
            label="Enter PG Educational Details"
            id="custom-css-outlined-input"
            size="small"
            sx={{ width: "90%", mb: "2%", background: COLORS.primary }}
            value={pgDegree}
            onChange={(e) => setPgDegree(e.target.value)}
          />
        </Box>

        <Box
          gridColumn="span 12"
          sx={{ marginTop: "auto", textAlign: "right", width: "90%" }}
        >
          <Button
            type="button"
            className="btn btn-sm rounded-2 fw-medium"
            onClick={clearForm}
            sx={{
              border: "1px solid",
              color: COLORS.button,
              "&:hover": {
                color: COLORS.hover_btn,
              },
              width: "120px",
              height: "35px",
              borderRadius: "10px",
              marginRight: "2%",
            }}
          >
            Clear
          </Button>

          <Button
            type="submit"
            className="btn btn-sm rounded-2 fw-medium"
            sx={{
              background: COLORS.button,
              "&:hover": {
                background: COLORS.hover_btn,
              },
              color: COLORS.background,
              width: "120px",
              height: "35px",
              borderRadius: "10px",
            }}
            onClick={(e) => saveJobDetails(e)}
          >
            Submit
          </Button>
        </Box>

        <br />
        <br />
        <br />
        <br />
        <br />
      </Box>
    </div>
  );
};

export default JobDescription;